import React from 'react';
import { Carousel } from 'react-bootstrap';

function chunkArray(array = [], size) {
  if (!Array.isArray(array) || array.length === 0) return [];
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

const items = [
  {
   title:"Nippon Imports",
    video: "/video/Adv_1.mp4",
    description: `We are proud to partner with Nippon Imports, a trusted Japanese vehicle importer based in Sydney. Since 2005, they have been delivering quality new and pre-owned cars with exceptional customer service.

              At Nippon Imports, every car buying experience is made easy and enjoyable. Their knowledgeable team provides guidance, flexible financing options, and reliable servicing to help customers drive away in the perfect vehicle.

              Visit their headquarters in Ingleburn to explore their extensive range of vehicles and experience why Nippon Imports has been a leader in the Australian automotive community for nearly two decades.`
  }
  
];

export default function CardCarousel({ chunkSize = 1, darkMode = false }) {
  const chunkedItems = chunkArray(items, chunkSize);

  if (chunkedItems.length === 0) {
    return <p>No items to display</p>;
  }


  {/*
  return (
    <div className={`container-fluid shadow`}>
      <h1 className='text-dark text-center'>Advertising Partners</h1>
      <Carousel controls  indicators  interval={5000}>    
        {chunkedItems.map((group, idx) => (
          <Carousel.Item key={idx}>  
            <div className="row justify-content-center align-items-center">
              
              {group.map((item, index) => (
                <div className="col-auto mb-4" key={index}>
                  
                  <div
                    className="card-carousel-item d-flex flex-column align-items-center justify-content-center text-center"
                    style={{
                      width: '100vw',
                      height: 'auto',
                      
                      color: 'white',
                      borderRadius: '15px',
                      cursor: 'pointer',
                      transition: 'transform 0.3s, box-shadow 0.3s',
                    }}
                    /*onMouseEnter={e => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.3)';
                    }}*//*
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    
                    <div className="row align-items-start">
                    {/* Description Left *//*
                   <div className="col-md-6 d-flex flex-column justify-content-center h-100 px-4 text-start">

                    <h4 className="text-uppercase fw-bold text-dark">{item.title}</h4>
                     {item.description && <p className='text-dark 'style={{ color: '#495057', lineHeight: '1.6', fontSize: '1rem' }}>{item.description}</p>}
                    </div>
                   <div className="col-md-6 text-center mt-3 mt-md-0  h-100 px-3">

                    {item.video ? (
                      <video
                        src={item.video}
                        autoPlay
                        loop
                        muted
                        controls={false}
                        style={{ maxWidth: '100%', borderRadius: '10px', marginTop: '10px' }}
                      />
                    ) : null}
                    </div>
                  </div>
                  </div>
                </div>
              ))}
            </div>
          </Carousel.Item>  
        ))}
     </Carousel>   
    </div>
  );*/}



  return (
  <div className={`container-fluid shadow`}>
    <h1 className='text-dark text-center fw-bold'>Advertising Partners</h1>
    <Carousel controls={chunkedItems.length > 1} indicators={chunkedItems.length > 1} interval={5000}>
      {chunkedItems.map((group, idx) => (
        <Carousel.Item key={idx}>  
          <div className="row justify-content-center align-items-center">
            {group.map((item, index) => (
              <div className="col-auto mb-4" key={index}>
                <div
                  className="card-carousel-item d-flex flex-column align-items-center justify-content-center text-center"
                  style={{
                    width: '100vw',
                    height: 'auto',
                    color: 'white',
                    borderRadius: '15px',
                    cursor: 'pointer',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div className="row align-items-start">
                    {/* Description Left */}
                    <div className="col-md-6 d-flex flex-column justify-content-center h-100 px-4 text-start">
                      <h4 className="text-uppercase fw-bold text-dark">{item.title}</h4>
                      {item.description && (
                        <p className='text-dark' style={{ color: '#495057', lineHeight: '1.6', fontSize: '1rem' }}>
                          {item.description}
                        </p>
                      )}
                    </div>
                    <div className="col-md-6 text-center mt-3 mt-md-0 h-100 px-3">
                      {item.video ? (
                        <video
                          src={item.video}
                          autoPlay
                          loop
                          muted
                          controls={false}
                          style={{ maxWidth: '100%', borderRadius: '10px', marginTop: '10px' }}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  </div>
);

}



